import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export function Header({ title = "Lucky Night Teer" }) {
  return (
    <header className="nt-header-bg py-4 sm:py-5">
      <div className="nt-container flex items-center justify-center gap-3">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <Logo size={54} />
          <h1 className="font-display text-2xl sm:text-4xl font-extrabold tracking-tight text-[color:var(--nt-ink)]">
            {title}
          </h1>
        </Link>
      </div>
    </header>
  );
}

const SEO_CONTENT = `Welcome to Night Teer — your trusted destination for live Shillong Night Teer Result, Common Number and Dream Number updates. On this website you will get the latest Night Teer Result twice a day. First Round (F/R) is played at 10:00 PM and Second Round (S/R) result is declared at 11:00 PM. We publish official Night Teer numbers, historical Previous Result archive and daily Common Number predictions so that Teer players from Shillong, Meghalaya and across India can plan their game responsibly.

Night Teer is one of the most popular archery based lottery games played in the North-East region of India. Every night hundreds of players wait for the Lucky Night Teer Result and use Common Numbers, Dream Meaning and Previous Result trends to guess the winning number. This platform is designed to be lightning fast, mobile-friendly and 100% free so that even users on slow networks can view the Night Teer number without any delay.

Popular sections of this website include Common Number, Dream Number Chart, Previous Result archive, Teer Calendar and Reputed Counter list. You can bookmark this page and refresh at 10:00 PM and 11:00 PM to see the latest Night Teer Result live. Please note that Night Teer / Lucky Night Teer is a game of luck and this website is only for information & entertainment purposes.`;

export function Footer() {
  return (
    <footer className="mt-10 pt-6 pb-8 bg-[color:var(--nt-sky-soft)] border-t-2 border-red-400">
      <div className="nt-container">
        {/* SEO content */}
        <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm">
          <h2 className="font-display text-xl sm:text-2xl mb-3 text-[color:var(--nt-ink)]">
            About Night Teer &amp; Lucky Night Teer Result
          </h2>
          {SEO_CONTENT.split("\n\n").map((p, i) => (
            <p
              key={i}
              className="text-[13.5px] sm:text-sm leading-relaxed text-slate-800 font-medium mb-3 last:mb-0"
            >
              {p}
            </p>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="mt-6 bg-yellow-50 border-l-4 border-yellow-500 rounded-md p-4">
          <h3 className="font-extrabold text-[color:var(--nt-ink)] mb-1">Disclaimer</h3>
          <p className="text-[13px] leading-relaxed text-slate-800">
            These common numbers, dream numbers and predictions are purely based on
            certain calculations done using past results. There is no guarantee of the
            accuracy of these numbers. Night Teer / Lucky Night Teer is a game of luck
            and this website is for information &amp; entertainment purposes only. Please
            play responsibly.
          </p>
        </div>

        {/* Social Links */}
        <div className="mt-6 text-center">
          <h3 className="font-display text-lg mb-3">Follow us on social media</h3>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              data-testid="social-telegram"
              href="https://t.me/MorningSundayTeer"
              target="_blank"
              rel="noreferrer noopener"
              className="nt-btn nt-btn-blue"
              style={{ background: "#229ED9" }}
            >
              <i className="fa-brands fa-telegram mr-2" /> Telegram
            </a>
            <a
              data-testid="social-whatsapp"
              href="https://whatsapp.com/channel/0029Vb8MzS9F1YlWpvY4M81x"
              target="_blank"
              rel="noreferrer noopener"
              className="nt-btn nt-btn-green"
              style={{ background: "#25D366" }}
            >
              <i className="fa-brands fa-whatsapp mr-2" /> WhatsApp
            </a>
            <a
              data-testid="social-facebook"
              href="https://www.facebook.com/share/18nZVtunj6/"
              target="_blank"
              rel="noreferrer noopener"
              className="nt-btn"
              style={{ background: "#1877F2" }}
            >
              <i className="fa-brands fa-facebook mr-2" /> Facebook
            </a>
            <a
              data-testid="social-youtube"
              href="https://youtube.com/@morningteerliveresult?si=EVVZwViXcUBP7RGt"
              target="_blank"
              rel="noreferrer noopener"
              className="nt-btn nt-btn-red"
              style={{ background: "#FF0000" }}
            >
              <i className="fa-brands fa-youtube mr-2" /> YouTube
            </a>
          </div>
        </div>

        <div className="mt-6 text-center text-xs sm:text-sm">
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-blue-700 font-bold">
            <Link to="/" data-testid="footer-home">Home</Link>
            <span>|</span>
            <Link to="/terms" data-testid="footer-terms">Terms and Conditions</Link>
            <span>|</span>
            <Link to="/about" data-testid="footer-about">About Us</Link>
            <span>|</span>
            <Link to="/blog" data-testid="footer-blog">Blog</Link>
            <span>|</span>
            <Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link>
            <span>|</span>
            <Link to="/contact" data-testid="footer-contact">Contact Us</Link>
            <span>|</span>
            <Link to="/admin/login" data-testid="footer-admin" className="text-slate-700">Admin</Link>
          </div>
          <div className="mt-2 text-slate-700 font-semibold">
            Copyright © : All site reserved 2016 - {new Date().getFullYear()}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function PublicLayout({ title = "Lucky Night Teer", children }) {
  return (
    <div className="App">
      <Header title={title} />
      <main className="pb-8">{children}</main>
      <Footer />
    </div>
  );
}
